// this matches the JSON response from open AI, do not change the value
export enum QuickDistributionElementEnum {
    subjectLine = 'subjectLine',
    previewText = 'previewText',
    headline = 'headline',
    subHeadline = 'subHeadline',
    marketingPitch = 'marketingPitch',
    body = 'body',
    marketingConclusion = 'marketingConclusion',
    aboutUs = 'aboutUs',
    contactUs = 'contactUs'
}
